import React, { FunctionComponent, useEffect, useRef, useContext } from "react";
import classNames from "classnames";
import { IntlContext } from "../helpers";
import { FormattedMessage } from "react-intl-phraseapp";

interface FocusableHeaderProps {
  className?: string;
  text: string | { id: string; values: { [key: string]: string } };
  ignoreFocus?: boolean;
  srOnly?: boolean;
}

const FocusableHeader: FunctionComponent<FocusableHeaderProps> = ({
  className = "",
  text,
  ignoreFocus,
  srOnly,
}) => {
  const ref = useRef<HTMLHeadingElement>(null);
  const fm = useContext(IntlContext).formatMessage;

  useEffect(() => {
    if (!ignoreFocus) {
      ref.current?.focus();
    }
  }, [ref, text, ignoreFocus]);

  useEffect(() => {
    document.title =
      typeof text === "string" ? text : fm({ id: text.id }, text.values);
  }, [text]);

  return (
    <h1
      ref={ref}
      className={classNames(className, {
        "ds-u-visibility--screen-reader": srOnly,
      })}
      tabIndex={-1}
    >
      {typeof text === "string" ? (
        `${text}`
      ) : (
        <>
          <FormattedMessage id={text.id} values={text.values} />
        </>
      )}
    </h1>
  );
};

export default FocusableHeader;
